/**
 * 戦果関連任務
 * @static
 * @memberof Const
 */
export const EXPEDITIONS = [
  {
    world: 1,
    id: 'A2',
    name: '海峡警備行動',
    statuses: { fire: 50, antiAir: 70, asw: 180 },
    types: [{ DE: 4 }],
    minFlagshipLv: 20,
    totalLevel: 20,
    minCount: 4,
  },
  {
    world: 1,
    id: 'A3',
    name: '長時間対潜警戒',
    statuses: { asw: 280, scout: 60 },
    types: [{ CL: 1, DE: 3 }],
    minFlagshipLv: 35,
    totalLevel: 185,
    minCount: 5,
  },
  {
    world: 1,
    id: 'A4',
    name: '南西方面連絡線哨戒',
    statuses: {
      fire: 300, antiAir: 200, asw: 200, scout: 120,
    },
    types: [{ CL: 1, DD: 2 }],
    minFlagshipLv: 40,
    totalLevel: 200,
    minCount: 5,
  },
  {
    world: 1,
    id: 'A5',
    name: '小笠原沖哨戒線',
    statuses: {
      fire: 280, antiAir: 220, asw: 240, scout: 150,
    },
    types: [{ CL: 1, DD: 3 }],
    minFlagshipLv: 45,
    totalLevel: 230,
    minCount: 5,
  },
  {
    world: 1,
    id: 'A6',
    name: '小笠原沖戦闘哨戒',
    statuses: {
      fire: 330, antiAir: 300, asw: 270, scout: 180,
    },
    types: [{ CL: 1, DD: 3 }],
    minFlagshipLv: 55,
    totalLevel: 290,
    minCount: 6,
  },
  {
    world: 2,
    id: 'B1',
    name: '南西方面航空偵察作戦',
    statuses: { antiAir: 200, asw: 200, scout: 140 },
    types: [{ AV: 1, CL: 1, DE: 2 }],
    minFlagshipLv: 40,
    totalLevel: 150,
    minCount: 6,
  },
  {
    world: 2,
    id: 'B2',
    name: '敵泊地強襲反撃作戦',
    statuses: {
      fire: 360, antiAir: 160, asw: 160, scout: 140,
    },
    types: [{ CA: 1, CL: 1, DD: 3 }],
    minFlagshipLv: 45,
    totalLevel: 220,
    minCount: 6,
  },
  {
    world: 2,
    id: 'B3',
    name: '南西諸島離島哨戒作戦',
    statuses: {
      fire: 400, antiAir: 220, asw: 220, scout: 190,
    },
    types: [{ AV: 1, CL: 1, DE: 4 }],
    minFlagshipLv: 50,
    totalLevel: 250,
    minCount: 6,
  },
  {
    world: 2,
    id: 'B4',
    name: '南西諸島離島防衛作戦',
    statuses: {
      fire: 500, antiAir: 280, asw: 280, scout: 170,
    },
    types: [{
      CA: 2, CL: 1, DD: 2, SS: 1,
    }],
    minFlagshipLv: 55,
    totalLevel: 300,
    minCount: 6,
  },
  {
    world: 2,
    id: 'B5',
    name: '南西諸島捜索撃滅戦',
    statuses: {
      fire: 510, antiAir: 400, asw: 285, scout: 385,
    },
    types: [{ AV: 1, CL: 1, DD: 2 }],
    minFlagshipLv: 60,
    totalLevel: 330,
    minCount: 6,
  },
  {
    world: 2,
    id: 'B6',
    name: '精鋭水雷戦隊夜襲',
    statuses: {
      fire: 410, antiAir: 390, asw: 410, scout: 340,
    },
    types: [{ CL: 1, DD: 5 }],
    minFlagshipLv: 75,
    totalLevel: 400,
    minCount: 6,
  },
  {
    world: 7,
    id: '41',
    name: 'ブルネイ泊地沖哨戒',
    statuses: { fire: 60, antiAir: 80, asw: 210 },
    types: [{ DE: 3 }],
    minFlagshipLv: 30,
    totalLevel: 100,
    minCount: 3,
  },
  {
    world: 7,
    id: '42',
    name: 'ミ船団護衛(一号船団)',
    statuses: {},
    types: [{ CL: 1, DD: 2 }],
    minFlagshipLv: 45,
    totalLevel: 200,
    minCount: 4,
  },
  {
    world: 7,
    id: '43',
    name: 'ミ船団護衛(二号船団)',
    statuses: {
      fire: 500, antiAir: 280, asw: 280, scout: 170,
    },
    types: [{ ECVL: 1, DE: 2 },
      { CVL: 1, CL: 1, DD: 4 }],
    minFlagshipLv: 55,
    totalLevel: 300,
    minCount: 6,
  },
  {
    world: 7,
    id: '44',
    name: '航空装備輸送任務',
    statuses: { antiAir: 200, asw: 200, scout: 150 },
    types: [{
      CV: 1, AV: 1, CL: 1, DE: 2,
    }],
    minFlagshipLv: 35,
    totalLevel: 210,
    minCount: 6,
  },
  {
    world: 7,
    id: '45',
    name: 'ボーキサイト船団護衛',
    statuses: { antiAir: 240, asw: 300, scout: 180 },
    types: [{ CVL: 1, DE: 4 }],
    minFlagshipLv: 50,
    totalLevel: 240,
    minCount: 5,
  },
  {
    world: 7,
    id: '46',
    name: '南西海域戦闘哨戒',
    statuses: {
      fire: 350, antiAir: 250, asw: 220, scout: 190,
    },
    types: [{ CA: 2, CL: 1, DD: 2 }],
    minFlagshipLv: 60,
    totalLevel: 300,
    minCount: 5,
  },
  {
    world: 4,
    id: 'D1',
    name: '西方海域偵察作戦',
    statuses: { antiAir: 240, asw: 240, scout: 300 },
    types: [{ AV: 1, DD: 3 }],
    minFlagshipLv: 50,
    totalLevel: 200,
    minCount: 5,
  },
  {
    world: 4,
    id: 'D2',
    name: '西方潜水艦作戦',
    statuses: { fire: 60, antiAir: 80, asw: 50 },
    types: [{ AS: 1, SS: 3 }],
    minFlagshipLv: 55,
    totalLevel: 270,
    minCount: 5,
  },
  {
    world: 4,
    id: 'D3',
    name: '欧州方面友軍との接触',
    statuses: {
      fire: 115, antiAir: 90, asw: 70, scout: 95,
    },
    types: [{ AS: 1, SS: 3 }],
    minFlagshipLv: 65,
    totalLevel: 350,
    minCount: 5,
  },
  {
    world: 5,
    id: 'E1',
    name: 'ラバウル方面艦隊進出',
    statuses: {
      fire: 450, antiAir: 350, asw: 330, scout: 250,
    },
    types: [{ CA: 1, CL: 1, DD: 3 }],
    minFlagshipLv: 55,
    totalLevel: 290,
    minCount: 6,
  },
  {
    world: 5,
    id: 'E2',
    name: '強行鼠輸送作戦',
    statuses: {
      fire: 280, antiAir: 240, asw: 200, scout: 160,
    },
    types: [{ DD: 5 }],
    minFlagshipLv: 70,
    totalLevel: 320,
    minCount: 5,
  },
];

export type Expedition = typeof EXPEDITIONS[number];
